import * as R from 'ramda';
import { ActionType } from '../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../../core/api/rsaa';
import { Endpoints } from '../../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../core/api/module';
import { EmailBody } from '../../survey/raters/models';


const KEY_ACTION = ActionType.EQScoresEmailPreviewRequest;
const ACTIONS    = [
  ActionType.EQScoresEmailPreviewRequest,
  ActionType.EQScoresEmailPreviewResponse,
  ActionType.EQScoresEmailPreviewError,
];


type Payload = EmailBody;


type Meta = {
  languageId: number;
};


/**
 * Dispatch this action to retrieve the email template used for sending EQ scores to participant-selected recipients
 *
 * @param languageId - the language in which the template should be returned
 */
export const eqScoresEmailPreviewAction = (
  languageId: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.EQScoresEmailPreview,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({
      languageId: languageId,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { languageId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${languageId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const metaTag = `${action.meta.languageId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  return R.assocPath(
    ['eqScoresEmailTemplates', metaTag],
    payload,
    successState,
  );
};

export const eqScoresEmailPreviewReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
